<div class="privacy-container">
  <h1 i18n="@@footer.privacy.title">Datenschutzerklärung</h1>

  <section>
    <h2 i18n="@@footer.privacy.section1">1. Verantwortlicher</h2>
    <p>
      {{ clientName }}<br />
      {{ clientAddress }}<br />
      {{ clientCity }}
      <br />
      <a [href]="'mailto:' + clientEmail">{{ clientEmail }}</a
      ><br />
      <span i18n="@@footer.privacy.dpo">Datenschutzbeauftragter</span>:
      <a [href]="'mailto:' + clientDPOEmail">{{ clientDPOEmail }}</a>
    </p>
    <p i18n="@@footer.privacy.awoPrivacyReference">
      Diese Datenschutzerklärung bezieht sich auf die technische Nutzung der
      Webapp. Informationen zur Verarbeitung personenbezogener Daten im Rahmen
      der Betreuungsleistungen (z.B. Daten der Kinder, Gesundheitsdaten,
      Zahlungsdaten) entnehmen Sie bitte der Datenschutzerklärung der AWO
      Perspektiven gGmbH, die im Rahmen der Anmeldung bereitgestellt wird.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section2">
      2. Technischer Dienstleister und Auftragsverarbeiter
    </h2>
    <p i18n="@@footer.privacy.technicalProvider">
      Wir arbeiten mit folgendem technischen Dienstleister als
      Auftragsverarbeiter zusammen:
    </p>
    <p>
      {{ company }}<br />
      {{ address }}<br />
      {{ city }}
      <br />
      <a [href]="'mailto:' + email">{{ email }}</a>
    </p>
    <p i18n="@@footer.privacy.technicalProviderDescription">
      Der technische Dienstleister ist für die Bereitstellung und den Betrieb
      der technischen Infrastruktur der Webapp verantwortlich. Die Verarbeitung
      der Daten erfolgt ausschließlich im Auftrag und nach Weisung des
      Verantwortlichen auf Grundlage eines Auftragsverarbeitungsvertrags gemäß
      Art. 28 DSGVO.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section3">
      3. Erhebung und Verarbeitung personenbezogener Daten
    </h2>
    <p i18n="@@footer.privacy.dataCollection">
      Für die Nutzung der Webapp erheben und verarbeiten wir folgende Daten:
    </p>
    <ul>
      <li>
        <strong i18n="@@footer.privacy.dataCollectionEmail.label"
          >E-Mail-Adresse</strong
        >
        <span i18n="@@footer.privacy.dataCollectionEmail.description"
          >Für die Anmeldung, Passwort-Zurücksetzung, Benachrichtigungen und
          Kommunikation innerhalb der Plattform.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.dataCollectionPassword.label"
          >Passwort</strong
        >
        <span i18n="@@footer.privacy.dataCollectionPassword.description"
          >In verschlüsselter Form gespeichert, um den Zugriff auf Ihr Konto zu
          schützen.</span
        >
      </li>
    </ul>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section4">4. Zweck der Datenverarbeitung</h2>
    <p i18n="@@footer.privacy.dataProcessingPurpose">
      Die erhobenen Daten nutzen wir ausschließlich für folgende Zwecke:
    </p>
    <ul>
      <li>
        <strong i18n="@@footer.privacy.dataProcessingPurposeProvision.label"
          >Bereitstellung der Webapp</strong
        >
        <span i18n="@@footer.privacy.dataProcessingPurposeProvision.description"
          >Wir verwenden Ihre Daten, um Ihnen die Funktionen der Webapp zur
          Verfügung zu stellen, wie z.B. das Erstellen, Bearbeiten und Verwalten
          von Aufträgen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.dataProcessingPurposeCommunication.label"
          >Kommunikation</strong
        >
        <span
          i18n="@@footer.privacy.dataProcessingPurposeCommunication.description"
          >Wir nutzen Ihre Kontaktdaten, um Ihnen wichtige Informationen zur
          Webapp zukommen zu lassen, wie z.B. Updates, Sicherheitshinweise oder
          Antworten auf Ihre Anfragen.</span
        >
      </li>
      <li>
        <strong
          i18n="@@footer.privacy.dataProcessingPurposeAuthentication.label"
          >Authentifizierung</strong
        >
        <span
          i18n="
            @@footer.privacy.dataProcessingPurposeAuthentication.description"
          >Ihr Passwort dient dazu, den unbefugten Zugriff auf Ihr Konto zu
          verhindern.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.dataProcessingPurposeAnalysis.label"
          >Analyse</strong
        >
        <span i18n="@@footer.privacy.dataProcessingPurposeAnalysis.description"
          >Wir werten Nutzungsdaten anonymisiert aus, um die Funktionalität der
          Webapp kontinuierlich zu verbessern.</span
        >
      </li>
    </ul>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section5">5. Rechtsgrundlage</h2>
    <p i18n="@@footer.privacy.legalBasis">
      Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage von
      Artikel 6 Absatz 1 lit. b DSGVO (Erfüllung eines Vertrags) und Artikel 6
      Absatz 1 lit. f DSGVO (berechtigtes Interesse). Unser berechtigtes
      Interesse besteht darin, unsere Dienstleistungen bereitzustellen und zu
      verbessern.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section6">6. Weitergabe von Daten</h2>
    <p i18n="@@footer.privacy.dataSharing">
      Wir geben Ihre personenbezogenen Daten grundsätzlich nicht an Dritte
      weiter. Ausnahmen gelten nur, wenn:
    </p>
    <ul>
      <li i18n="@@footer.privacy.dataSharingConsent">
        Sie uns Ihre ausdrückliche Einwilligung erteilt haben.
      </li>
      <li i18n="@@footer.privacy.dataSharingLegalObligation">
        Die Weitergabe zur Erfüllung rechtlicher Verpflichtungen erforderlich
        ist.
      </li>
      <li i18n="@@footer.privacy.dataSharingRightsEnforcement">
        Die Weitergabe zur Durchsetzung unserer Rechte erforderlich ist.
      </li>
    </ul>
    <p>
      <strong i18n="@@footer.privacy.dataSharingThirdParties"
        >Wir nutzen folgende Drittanbieter:</strong
      >
    </p>
    <ul>
      <li>
        <strong>Cloudflare</strong>
        <span i18n="@@footer.privacy.dataSharingCloudflare.description"
          >Zur Bereitstellung der Webapp und zum Schutz vor Cyberangriffen.
          Cloudflare verarbeitet Daten wie IP-Adressen und Browserinformationen,
          um eine sichere und schnelle Bereitstellung der Webapp zu
          gewährleisten.</span
        >
      </li>
      <li>
        <strong>Firebase</strong>
        <span i18n="@@footer.privacy.dataSharingFirebase.description"
          >Zur Bereitstellung verschiedener Dienste, darunter Hosting,
          Datenbank, Authentifizierung und Cloud Functions. Firebase, ein Dienst
          von Google, verarbeitet Daten zur Authentifizierung, Speicherung und
          zum Hosting von Inhalten sowie zur Ausführung von Cloud
          Functions.</span
        >
      </li>
      <li>
        <strong>Google reCAPTCHA</strong>
        <span i18n="@@footer.privacy.dataSharingRecaptcha.description"
          >Zum Schutz vor automatisierten Anfragen (Spam-Schutz). Dabei werden
          IP-Adresse und Nutzungsverhalten an Google übermittelt.</span
        >
      </li>
      <li>
        <strong>Firebase Performance Monitoring</strong>
        <span i18n="@@footer.privacy.dataSharingPerformance.description"
          >Optionaler Dienst zur Messung technischer Leistungsdaten (z.B.
          Seitenladezeiten, Antwortzeiten der Backend-Dienste, Netzwerkfehler).
          Übermittelt werden anonymisierte Performance-Metriken sowie eine
          pseudonyme Installations-ID. Es werden keine Inhalte Ihrer Eingaben
          oder personenbezogenen Daten aus Formularen erfasst. Anbieter ist
          Google Ireland Limited; eine Übermittlung an Google-Server außerhalb
          der EU ist nicht ausgeschlossen. Die Aktivierung erfolgt nur nach
          Ihrer Einwilligung über den Cookie-Banner (Kategorie „Analyse- und
          Performance-Cookies"). Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO
          (Einwilligung). Sie können Ihre Einwilligung jederzeit über die
          Cookie-Einstellungen widerrufen; bereits laufende Messungen enden mit
          dem nächsten Seitenneuladen.</span
        >
      </li>
      <li>
        <strong>Twilio SendGrid</strong>
        <span i18n="@@footer.privacy.dataSharingSendgrid.description"
          >Zum Versand transaktionaler E-Mails (z.B. Anmeldebestätigung,
          Passwort-Zurücksetzung, Benachrichtigungen). Übermittelt werden die
          Empfänger-E-Mail-Adresse sowie der jeweilige E-Mail-Inhalt. Zur
          Verifikation der Zustellbarkeit und zur Sicherstellung einer guten
          Versand-Reputation wird ein unsichtbarer 1×1-Pixel in jede E-Mail
          eingebettet, der beim Öffnen der Nachricht geladen wird (Open
          Tracking). Dabei werden Zeitpunkt der Öffnung und IP-Adresse des
          öffnenden Geräts an SendGrid übermittelt. Anbieter ist die Twilio
          Inc., USA; die Datenübertragung erfolgt auf Grundlage der
          EU-Standardvertragsklauseln und des EU-US Data Privacy Framework.
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
          Interesse an Zustellnachweis und Reputation des
          E-Mail-Versands).</span
        >
      </li>
    </ul>
    <p i18n="@@footer.privacy.dataSharingStorage">
      Ihre Daten werden primär in der EU gespeichert. Aufgrund der technischen
      Architektur von Google Firebase können Ihre Daten jedoch auch
      vorübergehend oder zur Verarbeitung in andere Regionen, einschließlich der
      USA, übertragen werden. Google hat sich verpflichtet, die
      Datenschutzstandards der EU einzuhalten und entsprechende
      Sicherheitsmaßnahmen getroffen. Weitere Informationen zu
      Datenschutzrichtlinien der Drittanbieter finden Sie hier:
    </p>
    <ul>
      <li>
        <a
          href="https://firebase.google.com/support/privacy?hl=de"
          target="_blank"
          i18n="@@footer.privacy.thirdPartyLink.firebase"
          >Datenschutzhinweise von Google Firebase</a
        >
      </li>
      <li>
        <a
          href="https://www.cloudflare.com/de-de/trust-hub/gdpr/"
          target="_blank"
          i18n="@@footer.privacy.thirdPartyLink.cloudflare"
          >DSGVO-Informationen von Cloudflare</a
        >
      </li>
      <li>
        <a
          href="https://policies.google.com/privacy?hl=de"
          target="_blank"
          i18n="@@footer.privacy.thirdPartyLink.google"
          >Datenschutzerklärung von Google</a
        >
      </li>
      <li>
        <a
          href="https://www.twilio.com/en-us/legal/privacy"
          target="_blank"
          i18n="@@footer.privacy.thirdPartyLink.twilio"
          >Datenschutzerklärung von Twilio</a
        >
      </li>
    </ul>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section6b">7. Kontaktformular</h2>
    <p i18n="@@footer.privacy.contactForm.intro">
      Wenn Sie unser Kontaktformular nutzen, erheben wir folgende Daten zur
      Bearbeitung Ihrer Anfrage:
    </p>
    <ul>
      <li>
        <strong i18n="@@footer.privacy.contactForm.nameEmail.label"
          >Name und E-Mail-Adresse</strong
        >
        <span i18n="@@footer.privacy.contactForm.nameEmail.description"
          >Zur Identifikation und Beantwortung Ihrer Anfrage.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.contactForm.message.label"
          >Nachricht und Kategorie</strong
        >
        <span i18n="@@footer.privacy.contactForm.message.description"
          >Zur inhaltlichen Bearbeitung Ihres Anliegens.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.contactForm.deviceInfo.label"
          >Geräteinformationen</strong
        >
        <span i18n="@@footer.privacy.contactForm.deviceInfo.description"
          >Betriebssystem, Browser und Bildschirmauflösung — zur Fehleranalyse
          bei technischen Problemen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.contactForm.ip.label"
          >IP-Adresse</strong
        >
        <span i18n="@@footer.privacy.contactForm.ip.description"
          >Zum Schutz vor missbräuchlicher Nutzung (Spam-Schutz). Die
          IP-Adresse wird regelmäßig und zeitnah gelöscht.</span
        >
      </li>
    </ul>
    <p i18n="@@footer.privacy.contactForm.legalBasis">
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung bzw.
      vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO
      (berechtigtes Interesse am Schutz vor Missbrauch). Die von Ihnen im
      Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur
      Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder
      der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener
      Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen —
      insbesondere Aufbewahrungsfristen — bleiben unberührt.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section7">8. Dauer der Datenspeicherung</h2>
    <p i18n="@@footer.privacy.dataRetention">
      Wir speichern Ihre personenbezogenen Daten grundsätzlich nur so lange, wie
      es für die Erfüllung der oben genannten Zwecke erforderlich ist oder
      gesetzliche Aufbewahrungsfristen bestehen. Nach Ablauf dieser Fristen
      werden Ihre Daten gelöscht. Sofern Sie uns zur Löschung auffordern oder
      Ihre Einwilligung zur Speicherung widerrufen, werden Ihre Daten
      umgehend gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
      entgegenstehen.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section8">9. Ihre Rechte</h2>
    <p i18n="@@footer.privacy.yourRights">Sie haben das Recht auf:</p>
    <ul>
      <li>
        <strong i18n="@@footer.privacy.rightsAccess.label">Auskunft</strong>
        <span i18n="@@footer.privacy.rightsAccess.description"
          >Sie können jederzeit Auskunft über Ihre bei uns gespeicherten
          personenbezogenen Daten verlangen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.rightsRectification.label"
          >Berichtigung</strong
        >
        <span i18n="@@footer.privacy.rightsRectification.description"
          >Sollten unrichtige Daten gespeichert sein, können Sie deren
          Berichtigung verlangen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.rightsErasure.label">Löschung</strong>
        <span i18n="@@footer.privacy.rightsErasure.description"
          >Unter bestimmten Voraussetzungen können Sie die Löschung Ihrer Daten
          verlangen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.rightsRestriction.label"
          >Einschränkung der Verarbeitung</strong
        >
        <span i18n="@@footer.privacy.rightsRestriction.description"
          >Sie können die Einschränkung der Verarbeitung Ihrer Daten
          verlangen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.rightsDataPortability.label"
          >Datenübertragbarkeit</strong
        >
        <span i18n="@@footer.privacy.rightsDataPortability.description"
          >Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und
          maschinenlesbaren Format zu erhalten oder an einen anderen
          Verantwortlichen übermitteln zu lassen.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.rightsObjection.label"
          >Widerspruch</strong
        >
        <span i18n="@@footer.privacy.rightsObjection.description"
          >Sie können der Verarbeitung Ihrer Daten widersprechen, soweit diese
          auf Grundlage von Artikel 6 Absatz 1 lit. f DSGVO erfolgt.</span
        >
      </li>
      <li>
        <strong i18n="@@footer.privacy.rightsComplaint.label"
          >Beschwerde bei der Aufsichtsbehörde</strong
        >
        <span i18n="@@footer.privacy.rightsComplaint.description"
          >Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde
          über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren
          (Art. 77 DSGVO).</span
        >
      </li>
    </ul>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section9">10. Sicherheit</h2>
    <p i18n="@@footer.privacy.security">
      Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten gegen
      zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder den
      Zugriff unberechtigter Personen zu schützen.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section10">
      11. Änderungen dieser Datenschutzerklärung
    </h2>
    <p i18n="@@footer.privacy.changes">
      Wir behalten uns vor, diese Datenschutzerklärung jederzeit anzupassen.
      Über wesentliche Änderungen werden wir Sie rechtzeitig informieren.
    </p>
  </section>

  <section>
    <h2 i18n="@@footer.privacy.section11">12. Kontakt für Datenschutzfragen</h2>
    <p>
      <span i18n="@@footer.privacy.contact"
        >Bei Fragen zum Datenschutz wenden Sie sich bitte an</span
      >:<br />
      {{ clientName }}<br />
      <a [href]="'mailto:' + clientEmail">{{ clientEmail }}</a>
    </p>
  </section>

  <awo-care-back-to-home />
</div>
